// @flow

import React from 'react';
import * as Immutable from 'immutable';
import { connect } from 'react-redux';
import { Message } from 'semantic-ui-react';
import { getThread, getIsReading } from '../reducers/threads';
import {
  getIsFetching,
  getIsFetchingPrevious,
  getIsError,
  getIsSending,
  getIsSendError,
  getMessages,
  getLastReadIndex,
  getCurrentScrollPosition,
} from '../reducers/messages';
import { Header, List, NewMessage, NoMessage } from '../components/messages';
import { ListLoader } from '../components/shared';
import { trackThread, readThread } from '../actions/threads';
import {
  fetchMessages,
  sendMessage,
  fetchPreviousMessages,
} from '../actions/messages';
import type { Thread, ThreadMessage } from '../types';
import type { State as StoreState } from '../reducers';

type Props = {
  id: string,
  thread: Thread,
  messages: Immutable.List<ThreadMessage>,
  lastReadIndex?: number,
  scrollPosition?: number,
  isFetching: boolean,
  isFetchingPrevious: boolean,
  isError: boolean,
  isSending: boolean,
  isSendError: boolean,
  isReading: boolean,
  fetchMessages: (id: string) => void,
  fetchPreviousMessages: (id: string, scrollHeight: number) => void,
  sendMessage: (id: string, content: string, files: Array<File>) => void,
  trackThread: (id: string, value: boolean) => void,
  readThread: (id: string, idnex: number) => void,
};
type State = {
  hasNewMessage: boolean,
};

const mapStateToProps = (state: StoreState, props) => {
  return {
    id: props.match.params.id,
    thread: getThread(state, props.match.params.id),
    messages: getMessages(state),
    lastReadIndex: getLastReadIndex(state),
    scrollPosition: getCurrentScrollPosition(state),
    isFetching: getIsFetching(state),
    isFetchingPrevious: getIsFetchingPrevious(state),
    isError: getIsError(state),
    isSending: getIsSending(state),
    isSendError: getIsSendError(state),
    isReading: getIsReading(state),
  };
};

class Messages extends React.Component<Props, State> {
  props: Props;
  state: State;

  constructor(props: Props) {
    super(props);

    this.state = {
      hasNewMessage: false,
    };
  }

  componentDidMount() {
    this.props.fetchMessages(this.props.id);
  }

  onShowNewMessage = (value: boolean) =>
    this.setState({
      hasNewMessage: value,
    });

  onHideNewMessage = () =>
    this.setState({
      hasNewMessage: false,
    });

  renderList() {
    const {
      id,
      isFetching,
      isFetchingPrevious,
      isError,
      isReading,
      messages,
      lastReadIndex,
      scrollPosition,
      fetchPreviousMessages,
      readThread,
    } = this.props;

    if (isFetching) {
      return <ListLoader title="Chargement des messages..." />;
    }

    if (isError) {
      return (
        <Message
          error
          header="Une erreur est survenue pendant le chargement des messages"
          content="Veuillez nous excuser pour les désagréments occasionnés"
          icon="bomb"
        />
      );
    }

    if (messages.size === 0) {
      return <NoMessage />;
    }

    const read = (index: number) => readThread(id, index);
    const fetchPrevious = scrollHeight =>
      fetchPreviousMessages(id, scrollHeight);

    return (
      <List
        isFetching={isFetching}
        isFetchingPrevious={isFetchingPrevious}
        isError={isError}
        isReading={isReading}
        messages={messages}
        lastReadIndex={lastReadIndex}
        scrollPosition={scrollPosition}
        onRequestPreviousMessages={fetchPrevious}
        onReadUpToIndex={read}
        onShowNewMessage={this.onShowNewMessage}
      />
    );
  }

  render() {
    const {
      id,
      isSending,
      isSendError,
      thread,
      sendMessage,
      trackThread,
    } = this.props;

    const { hasNewMessage } = this.state;

    const send = (content: string, files: Array<File>) =>
      sendMessage(id, content, files);
    const track = (value: boolean) => trackThread(id, value);

    if (thread != null) {
      return (
        <div className="list-container">
          <Header
            thread={thread}
            hasNewMessage={hasNewMessage}
            onTrack={track}
            onHideNewMessage={this.onHideNewMessage}
          />
          {this.renderList()}
          <NewMessage
            isSending={isSending}
            isError={isSendError}
            onSendContent={send}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

export default connect(mapStateToProps, {
  fetchMessages,
  sendMessage,
  trackThread,
  readThread,
  fetchPreviousMessages,
})(Messages);



// WEBPACK FOOTER //
// ./src/modules/messaging/pages/Messages.js